import { isAnalyticsAppPath } from './analytics-app';
import { isWorkeffyPath } from './workeffy';

/**
 * `/w/*` (workeffy) and `/a/*` (analytics) are served by sibling SPAs, not Next.js pages.
 * The Next router cannot route into them, so crossing over needs a full page load.
 */
export const isExternalAppPath = (path: string) => isWorkeffyPath(path) || isAnalyticsAppPath(path);
